import HasRole from "modules/5_view_helpers/HasRole";
import { createCustomFormLinks, createMenuItems } from "../helpers";

const getHireageNav = (hireages_custom_forms, hireages_menus) => {
  const HireageRoles = HasRole({ category: "Hireages" });

  if (HireageRoles || _.isNotEmpty(hireages_custom_forms) || _.isNotEmpty(hireages_menus)) {
    let hireageMenu = { icon: "fa fa-calendar", label: "Hireages", content: [] };

    const HireExternalRoles = HasRole({
      resource_type: "Hireages::External",
    });
    if (HireExternalRoles) {
      hireageMenu.content.push({
        label: "External",
        to: "/hireages/externals",
      });
    }

    const HireCategoryRoles = HasRole({
      resource_type: "Hireages::Category",
    });
    if (HireCategoryRoles) {
      hireageMenu.content.push({
        label: "Categories",
        to: "/hireages/categories",
      });
    }

    hireageMenu.content = _.concat(
      hireageMenu?.content,
      createCustomFormLinks(hireages_custom_forms),
      createMenuItems(hireages_menus)
    );

    return hireageMenu;
  }
};

export default getHireageNav;
